<template>
  <h4>Страховка: <strong>{{ formattedInsurance }}</strong></h4>
</template>

<script>
  import utils from '../../../../utils';

  export default {
    name: "PlayerInsuranceLabel",
    props: ['insurance'],
    computed: {
      formattedInsurance() {
        const { insurance } = this;
        if (Number.isNaN(insurance)) {
          return 0;
        }
        return utils.convertSystemToCurrency(insurance);
      }
    }
  }
</script>

<style scoped>
  h4 {
    font-size: 12px;
    color: #666;
    font-family: Verdana,sans-serif;
    font-weight: normal;
  }

  strong {
    color: #66add6;
  }
</style>
